<mat-icon
  class="material-icons--outlined"
  aria-hidden="false"
  [class]="condition() ? 'rs-color--green--600' : 'rs-color--grey--700'"
  [attr.data-testid]="condition() ? 'rs-active-icon' : 'rs-inactive-icon'"
>
  {{ condition() ? 'check_circle' : 'highlight_off' }}
</mat-icon>